import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Redirect } from "react-router-dom";
// import AddArticle from '../DiscoverNew/Components/AddArticle';
import Discover from "../DiscoverNew";
import Landing from "../Landing";
import userStore from "../../Stores/User";
import queryString from "query-string";
import loading from "../../Assets/loading.gif";
import Loader from "../../Components/Loader";

const ContentSwitch = observer(({ history }) => {
  const pathname = history.location.pathname;
  const USER_ID = queryString.parse(history.location.search).USER_ID;

  useEffect(() => {
    console.log("userStore.isSignedIn", userStore.isSignedIn)
    if (userStore.isSignedIn) {
      // Use matchMedia instead of direct window.innerWidth check
      const isMobileView = window.matchMedia("(max-width: 1199.98px)").matches;
      // Change the CSS .intercom-lightweight-app-launcher bottom
      if (isMobileView) {
        document.documentElement.style.setProperty('--chat-bubble-bottom', '180px');
      } else {
        document.documentElement.style.setProperty('--chat-bubble-bottom', '106px');
      }
      
      // Add listener for screen size changes
      const mediaQueryList = window.matchMedia("(max-width: 1199.98px)");
      const handleMediaChange = (e) => {
        if (e.matches) {
          document.documentElement.style.setProperty('--chat-bubble-bottom', '180px');
        } else {
          document.documentElement.style.setProperty('--chat-bubble-bottom', '106px');
        }
      };
      
      mediaQueryList.addEventListener('change', handleMediaChange);
      
      return () => {
        mediaQueryList.removeEventListener('change', handleMediaChange);
      };
    } else {
      document.documentElement.style.setProperty('--chat-bubble-bottom', '106px');
    }
  }, [userStore.isSignedIn])

  if (userStore.isSignedIn === true) {
    // If user is on the root path, redirect to /add
    if (pathname === "/") {
      return <Redirect to="/add" />;
    }
    return <Discover />;
  }

  if (userStore.isSignedIn === false) {
    if (pathname !== "/") {
      // Always preserve all URL parameters when redirecting to signin
      const searchParams = new URLSearchParams(history.location.search);
      const currentParams = searchParams.toString();
      
      // Add source parameter if not present
      if (!searchParams.has('source')) {
        searchParams.set('source', pathname.slice(1) || 'landing');
      }
      
      if (USER_ID) {
        return <Redirect to={`/signin/${USER_ID}?${searchParams.toString()}`} />;
      } else {
        return <Redirect to={`/signin?${searchParams.toString()}`} />;
      }
    } else {
      // Preserve ALL URL parameters when showing landing page
      const searchParams = new URLSearchParams(history.location.search);
      const currentParams = searchParams.toString();
      
      // If we have params but they're not in the URL, update the URL
      if (currentParams && !history.location.search) {
        history.replace({
          pathname: '/',
          search: currentParams
        });
      }
      
      // Create a new Landing component with a key that includes all search params
      return <Landing key={searchParams.toString()} />;
    }
  }

  return <Loader />;
});

export default ContentSwitch;
